import React from 'react';

import {Tooltip, Typography} from 'antd';

import {getRiskDescription, getRiskType, toDisplayScore} from 'lib/fraudRisk';

type Props = {
  score?: number | null;
  emptyText?: React.ReactNode;
};

const {Text} = Typography;

export const FraudDetectorScore: React.FC<Props> = ({score, emptyText = null}) => {
  if (typeof score !== 'number') {
    return <>{emptyText}</>;
  }

  const displayScore = toDisplayScore(score);

  return (
    <Tooltip title={getRiskDescription(displayScore)}>
      <Text type={getRiskType(displayScore)} strong>
        {displayScore}
      </Text>
    </Tooltip>
  );
};
